module.exports = __webpack_public_path__ + "img/integrations-bigcommerce.c51dde01.png";